import { Modal } from '@innovationdepartment/proxima-ui';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import BrandProductsTaxonomyChangeModalConfirmationView from './BrandProducts.TaxonomyChangeModal.ConfirmationView';
import BrandProductsTaxonomyChangeModalView from './BrandProducts.TaxonomyChangeModal.View';
import type { TaxonomyChangeModalProps } from './types';

const DEBOUNCE_TIMEOUT = 1000;
const debouncer = debounce(
  (fn: (value: string) => void, value: string) => fn(value),
  DEBOUNCE_TIMEOUT
);

const BrandProductsTaxonomyChangeModal = (props: TaxonomyChangeModalProps) => {
  const {
    show,
    taxonomies,
    products,
    onTaxonomyFilterChange,
    onChangeClassificationClick,
    onFetchTaxonomies,
    onClose
  } = props;
  const [taxonomyToChange, setTaxonomyToChange] = useState<number | null>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  useEffect(() => {
    if (show) {
      onFetchTaxonomies?.();
    }
  }, [show]);

  const onTaxonomyClick = (taxonomyId: number) => {
    setTaxonomyToChange(taxonomyId);
  };

  const onSearchChange = (search: string) => {
    debouncer(onTaxonomyFilterChange, search);
  };

  const onCloseTaxonomyConfirm = () => {
    setTaxonomyToChange(null);
  };

  const onConfirmChange = async () => {
    if (taxonomyToChange) {
      await onChangeClassificationClick(`${taxonomyToChange}`);
      onCloseTaxonomyConfirm();
      onClose(true);
    }
  };

  return (
    <>
      <Modal resizable open={show} onClose={() => onClose()} title="Switch products categories">
        <BrandProductsTaxonomyChangeModalView
          {...props}
          onTaxonomyClick={onTaxonomyClick}
          onSearchChange={onSearchChange}
        />
      </Modal>
      <Modal
        allowCloseOnClickOutside
        open={!!taxonomyToChange}
        onClose={onCloseTaxonomyConfirm}
        title="Confirm classification changes"
      >
        <BrandProductsTaxonomyChangeModalConfirmationView
          products={products}
          taxonomy={taxonomies.find(t => t.id === taxonomyToChange)}
          onCancel={onCloseTaxonomyConfirm}
          onConfirm={onConfirmChange}
        />
      </Modal>
    </>
  );
};

export default BrandProductsTaxonomyChangeModal;
